export default __webpack_public_path__ + "static/media/abinbev.eb84beea.png";